define('vspot-angular/services/org-jobs-service',['angular'], function (ng) {
    'use strict';

    return ['resources.OrgJobs', '$rootScope', function (OrgJobs, $rootScope) {
        // Code for updating the repeating json when deleting jobs
        // The following will eventually return part1_json and part2_json, used by the server to
        // update all jobs in the sequence with the correct repeating_json

        var updateRepeatingJson = function (job, allFuture) {
            var repeatingPattern;
            var repeatingPatternToSend = {
                part1_json: null,
                part2_json: null
            };

            if (job.repeating_json && job.job_date) {
                repeatingPattern = JSON.parse(job.repeating_json);

                if (repeatingPattern.interval === 'irregular') {
                    if (allFuture) {
                        repeatingPatternToSend = prepAllFutureMultidayJobs(job.job_date, repeatingPattern);
                    } else {
                        repeatingPatternToSend = prepCurrentMultidayJob(job.job_date, repeatingPattern);
                    }
                } else {
                    if (allFuture) {
                        repeatingPatternToSend = prepAllFutureRepeatingJobs(job.job_date, repeatingPattern);
                    } else {
                        repeatingPatternToSend = prepCurrentRepeatingJob(job.job_date, repeatingPattern);
                    }
                }
            }

            return repeatingPatternToSend;
        };

        var prepAllFutureRepeatingJobs = function (jobDate, repeatingPattern) {
            var part1Json,
                part2Json;
            var oldPattern = {};
            var newPattern = {};

            // repeating pattern does not change if we're starting from the start
            if (!$rootScope.vspotDateIsEqual(jobDate, repeatingPattern.startdate)) {
                oldPattern.startdate = repeatingPattern.startdate;
                oldPattern.enddate = $rootScope.vspotShiftDate(jobDate, -1, 'day');
                newPattern.startdate = jobDate;
                newPattern.enddate = repeatingPattern.enddate;

                repeatingPattern.startdate = oldPattern.startdate;
                repeatingPattern.enddate = oldPattern.enddate;
                repeatingPattern.visibleEndDate = oldPattern.enddate;
                part1Json = JSON.stringify(repeatingPattern);

                repeatingPattern.startdate = newPattern.startdate;
                repeatingPattern.enddate = newPattern.enddate;
                repeatingPattern.visibleEndDate = newPattern.enddate;
                part2Json = JSON.stringify(repeatingPattern);
            } else {
                part1Json = JSON.stringify(repeatingPattern);
                part2Json = JSON.stringify(repeatingPattern);
            }

            return { part1_json: part1Json,
                     part2_json: part2Json };
        };

        var prepCurrentRepeatingJob = function (jobDate, repeatingPattern) {
            // update start date / end date if the job we're removing falls under
            // either end of the pattern. otherwise, no need to change anything
            if ($rootScope.vspotDateIsEqual(jobDate, repeatingPattern.startdate)) {
                repeatingPattern.startdate = $rootScope.vspotShiftDate(repeatingPattern.startdate, 1, 'day');
            } else if ($rootScope.vspotDateIsEqual(jobDate, repeatingPattern.enddate)) {
                repeatingPattern.enddate = $rootScope.vspotShiftDate(repeatingPattern.enddate, -1, 'day');
                repeatingPattern.visibleEndDate = $rootScope.vspotShiftDate(repeatingPattern.enddate, -1, 'day');
            }

            return { part1_json: JSON.stringify(repeatingPattern),
                     part2_json: null };
        };

        var prepAllFutureMultidayJobs = function (jobDate, repeatingPattern) {
            var i,
                date,
                part1Json,
                part2Json;
            var oldPattern = {
                days: []
            };
            var newPattern = {
                days: []
            };

            // split the days in half
            for (i = 0; i < repeatingPattern.days.length; i++) {
                date = repeatingPattern.days[i].date;

                if ($rootScope.vspotDateIsBefore(date, jobDate)) {
                    oldPattern.days.push(date);
                    oldPattern.startdate = updateStartDate(oldPattern.startdate, date);
                    oldPattern.enddate = updateEndDate(newPattern.enddate, date);
                } else {
                    newPattern.days.push(date);
                    newPattern.startdate = updateStartDate(newPattern.startdate, date);
                    newPattern.enddate = updateEndDate(newPattern.enddate, date);
                }
            }

            repeatingPattern.days = oldPattern.days;
            repeatingPattern.startdate = oldPattern.startdate;
            repeatingPattern.enddate = oldPattern.enddate;
            repeatingPattern.visibleEndDate = oldPattern.enddate;
            part1Json = JSON.stringify(repeatingPattern);

            repeatingPattern.days = newPattern.days;
            repeatingPattern.startdate = newPattern.startdate;
            repeatingPattern.enddate = newPattern.enddate;
            repeatingPattern.visibleEndDate = newPattern.enddate;
            part2Json = JSON.stringify(repeatingPattern);

            return { part1_json: part1Json,
                     part2_json: part2Json };
        };

        var prepCurrentMultidayJob = function (jobDate, repeatingPattern) {
            var i,
                date,
                startDate,
                endDate;
            var pattern = repeatingPattern;

            // remove the day from the list and update start/end date
            // if the day matches either of those
            for (i = 0; i < pattern.days.length; i++) {
                date = pattern.days[i].date;
                if ($rootScope.vspotDateIsEqual(jobDate, date)) {
                    pattern.days.splice(i, 1);
                } else {
                    startDate = updateStartDate(startDate, date);
                    endDate = updateEndDate(endDate, date);
                }
            }

            pattern.startdate = startDate;
            pattern.endDate = endDate;
            pattern.visibleEndDate = endDate;

            return { part1_json: JSON.stringify(pattern),
                     part2_json: null };
        };

        // keeps startDate up to date with the earliest date
        var updateStartDate = function (startDate, dateToCompare) {
            var result;

            if (!startDate) {
                result = dateToCompare;
            } else if ($rootScope.vspotDateIsAfter(startDate, dateToCompare)) {
                result = dateToCompare;
            } else {
                result = startDate;
            }

            return result;
        };

        // keeps end date up to date with the latest date
        var updateEndDate = function (endDate, dateToCompare) {
            var result;

            if (!endDate) {
                result = dateToCompare;
            } else if ($rootScope.vspotDateIsBefore(endDate, dateToCompare)) {
                result = dateToCompare;
            } else {
                result = endDate;
            }

            return result;
        };

        return {
            /*
             * Get a list of all the jobs for an activity. Results are paginated.
             *
             * @param sortType - How the data should be sorted from the server.
             *                  The options sent are the language file key for the
             *                  options shown to the user. i.e. [TBD].
             *
             * @param hidePastEvents - Whether or not to show activities wit no current jobs.
             * @param currentPage - Which page of the result set to show. 1 is the default.
             * @param itemsPerPage - How many items to show on each page of the result set. 10 is the default.
             *
             * @returns  Resource object. See /resources.js documentation for details
             */
            query: function(sortType, hidePastEvents, currentPage, itemsPerPage) {
                return OrgJobs.query({
                    order:              sortType,
                    hide_past_events:   hidePastEvents,
                    page:               currentPage,
                    items_per_page:     itemsPerPage
                });
            },

            get: function (id, activityId) {
                return OrgJobs.get({ id: id, selected_activity:  activityId});
            },

            save: function(postData) {
                return OrgJobs.save(postData);
            },

            update: function (postData) {
                return OrgJobs.update(postData);
            },

            updateRepeatingSchedule: function(postData) {
                var serverData  = {};
                var toSend      = [
                    'id',
                    'selected_activity',
                    'shifts',
                    'force',
                    'repeating_description',
                    'repeating_json'
                ];
                /* The above are the only params the server needs.
                *  Remove everything else to make debugging easier.
                */

                ng.forEach(postData, function(value, key) {
                  if( toSend.indexOf(key) !== -1 ) {
                    serverData[key] = value;
                  }
                });

                return OrgJobs.updateRepeatingSchedule(serverData);
            },

            getRepeatingCalendarInfo: function(activityId, jobId, volunteerId) {
                return OrgJobs.getRepeatingCalendarInfo({
                    selected_activity:  activityId,
                    job_id:             jobId,
                    volunteer_id:       volunteerId
                });
            },

            /* copyAssignmentsToRepeatingJobs:
             *  Copy a job assignment to an array of other jobs
             *
             * @param {int} activityId - Activity ID we are working on.
             * @param {int} jobAssignmentId - The assignment we want to copy.
             * @param {array} copyTo - Array of job ID's to copy the assignment to.
             */
            copyAssignmentsToRepeatingJobs: function(activityId, jobAssignmentId, copyTo) {
                return OrgJobs.copyAssignmentsToRepeatingJobs({
                    selected_activity:  activityId,
                    jobassignment_id:   jobAssignmentId,
                    jobs:               copyTo
                });
            },

            /*
             *  Deletes the given job.
             *
             *  @param id         [REQUIRED] [INT]     The job id.
             *  @param activityId [REQUIRED] [INT]     The activity id.
             *  @param allFuture  [REQUIRED] [BOOLEAN] Set to true to delete all future jobs from the deleted job's date.
             *                                         Set to false to delete just the given job.
             *  @param force      [OPTIONAL] [BOOLEAN] Set to true when a warning is given to the user, and they've
             *                                         confirmed they want to delete the assignments on the job.
             */
            delete: function(id, activityId, allFuture, force) {
                return OrgJobs.delete({
                    id:                 id,
                    selected_activity:  activityId,
                    delete_all:         allFuture,
                    force:              force
                });
            }
        };
    }];
});

